import { createAction } from 'redux-actions';

export const getSubscriptions = createAction('GET_SUBSCRIPTIONS');
export const getSubscriptionsSuccess = createAction('GET_SUBSCRIPTIONS_SUCCESS');
export const getSubscriptionsFailure = createAction('GET_SUBSCRIPTIONS_FAILURE');


